import { RootState } from '../reducers'
import { setNavDrawerExpanded as setNavDrawerExpandedInSlice } from '../slices/appLayoutSlice'

import { useDispatch } from './useDispatch'
import { useSelector } from './useSelector'

interface WorkCompletedTableFiltersHook {
  navDrawerExpanded: boolean
  setNavDrawerExpanded: (isExpanded: boolean) => void
}

const useAppLayoutState = (): WorkCompletedTableFiltersHook => {
  const dispatch = useDispatch()
  const navDrawerExpanded: boolean = useSelector(
    (state: RootState) => state.appLayout.navDrawerExpanded
  )

  const setNavDrawerExpanded = (isExpanded: boolean): void => {
    dispatch(setNavDrawerExpandedInSlice(isExpanded))
  }

  return {
    navDrawerExpanded,
    setNavDrawerExpanded,
  }
}

export default useAppLayoutState
